import { lazy } from "react";
import SuspenseWrapper from "components/SuspenseWrapper";

const VideoBanners = lazy(() => import("modules/video-banners/VideoBanners"));
export default function VideoBannersPage() {
  return (
    <SuspenseWrapper>
      <VideoBanners />
    </SuspenseWrapper>
  );
}

